module.exports = __webpack_public_path__ + "media/images/logo_en-83ecc0057a5be292a095a91fa99c993b.svg";